import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Col, Form, Input, Row, DatePicker } from "antd";
import { PAGINATION } from "../../_redux/constant";
import _ from "lodash";
import {includes, toLower} from "lodash";
import { removeVietnameseTones } from "lib/admin";
import { tripodThunks } from "../../_redux/thunk";
import AppBaseSelect from "../../../../../core/components/baseSelect";
import { TIME_FORMAT_WITHOUT_TIME } from "../../../app/_redux/constants";
import dayjs from "dayjs";
import TripodDailyLogList from "../../components/tripod-daily-log/tripodDailyLog";

let timer = null;
function TripodDailyLog() {
  const CARD_STYLE = {
    borderRadius: "0.42rem",
    boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)"
  };
  const today = new Date();
  const { RangePicker } = DatePicker;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { departments, stations } = useSelector(
    state => state.tripod.tripodDailyLog.filterData
  );
  const { data, total } = useSelector(
    state => state.tripod.tripodDailyLog.tripodDailyLogs
  );
  const [param, setParam] = useState({
    size: PAGINATION.size,
    page: PAGINATION.page,
    from: `${dayjs(today).format("YYYY-MM-DD")}`,
    to: `${dayjs(today).format("YYYY-MM-DD")}`
  });
  const dataSource = _.map(data, (item, index) => ({
    ...item,
    stt:
      param.page === 1 ? index + 1 : (param.page - 1) * param.size + index + 1
  }));
  const [loadingTripodLogList, setLoadingTripodDailyLogList] = useState(false);

  const _handleGetFilterDataTripodDailyLog = useCallback(async () => {
    await dispatch(tripodThunks.getDailyLogFilterDataThunk());
  }, []);
  const _handleGetListTripodDailyLog = useCallback(
    async () => {
      setLoadingTripodDailyLogList(true);
      await dispatch(tripodThunks.getTripodDailyLogListThunk(param));
      setLoadingTripodDailyLogList(false);
    },
    [param]
  );
  const _handleChangeInput = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      clearTimeout(timer);
      _handleChangeFilter();
    }, 800);
  };
  const _handleChangeFilter = () => {
    let from, to;
    const {
      time,
      department,
      fullname,
      station_id,
      username
    } = form.getFieldsValue();
    if (time) {
      from = dayjs(time[0]).format("YYYY-MM-DD");
      to = dayjs(time[1]).format("YYYY-MM-DD");
    }
    setParam(prev => ({
      ...prev,
      from,
      to,
      department,
      station_id,
      fullname,
      username,
      page: 1,
      size: 20
    }));
  };
  const _handleDisabledDate = current => {
    return current && current > dayjs().endOf("day");
  };

  const onChangeParam = param => {
    if (!param.page && !param.size) {
      param.page = PAGINATION.page;
      param.size = PAGINATION.size;
    }
    setParam(prev => ({ ...prev, ...param }));
  };

  useEffect(
    () => {
      _handleGetFilterDataTripodDailyLog();
      _handleGetListTripodDailyLog();
    },
    [_handleGetFilterDataTripodDailyLog, _handleGetListTripodDailyLog]
  );
  return (
    <Row gutter={[8, 8]}>
      <Col span={24}>
        <Card
          bodyStyle={{ paddingBottom: "0" }}
          size="small"
          style={CARD_STYLE}
        >
          <Row align="middle" justify="space-between" span={24}>
            <Form
              form={form}
              layout={"vertical"}
              style={{ width: "100%" }}
              initialValues={{
                time: [dayjs(today), dayjs(today)]
              }}
            >
              <Row gutter={[8]}>
                <Col className="gutter-row" span={6}>
                  <Form.Item label={"Ngày"} name={"time"}>
                    <RangePicker
                      disabledDate={_handleDisabledDate}
                      format={TIME_FORMAT_WITHOUT_TIME}
                      onChange={_handleChangeFilter}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={5}>
                  <Form.Item label="Username" name="username">
                    <Input
                      placeholder={"Username"}
                      onChange={_handleChangeInput}
                    />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={5}>
                  <Form.Item label="Tên nhân viên" name="fullname">
                    <Input
                      placeholder={"Tên nhân viên"}
                      onChange={_handleChangeInput}
                    />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={4}>
                  <Form.Item label="Kho" name="station_id">
                    <AppBaseSelect
                      allowConvert={true}
                      placeholder="Kho"
                      dataSource={stations}
                      valueKey="station_id"
                      labelKey="station_name"
                      onChange={_handleChangeFilter}
                      filterOption={(input, option) =>
                        includes(
                          toLower(removeVietnameseTones(option.label)), 
                          toLower(removeVietnameseTones(input))
                          )
                      }
                    />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={4}>
                  <Form.Item label="Phòng ban" name="department">
                    <AppBaseSelect
                      allowConvert={true}
                      placeholder="Phòng ban"
                      dataSource={_.map(departments, department => ({
                        key: department,
                        value: department
                      }))}
                      valueKey="key"
                      labelKey="value"
                      onChange={_handleChangeFilter}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Row>
        </Card>
      </Col>
      <Col span={24}>
        <TripodDailyLogList
          loading={loadingTripodLogList}
          dataSource={dataSource}
          stations={stations}
          total={total}
          param={param}
          departments={departments}
          onChangeParam={onChangeParam}
        />
      </Col>
    </Row>
  );
}

export default React.memo(TripodDailyLog);
